import { render, staticRenderFns } from "./PromotionLink.vue?vue&type=template&id=32d96f17&scoped=true"
import script from "./PromotionLink.vue?vue&type=script&lang=js"
export * from "./PromotionLink.vue?vue&type=script&lang=js"
import style0 from "./PromotionLink.vue?vue&type=style&index=0&id=32d96f17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d96f17",
  null
  
)

export default component.exports